export function roundToSignificantValue(value: number, precision = 2) {
  if (precision <= 0) return 0
  return parseFloat(value.toPrecision(precision))
}
